import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Text } from "@mantine/core";

import { CashRegisterStateEnum } from "@prostocheck/shared";
import { Card } from "@prostocheck/ui";

import { IBusinessUnitCardProps } from "./business-unit-card.models";

export const BusinessUnitCard = ({ businessUnit }: IBusinessUnitCardProps) => {
  const { t } = useTranslation();
  const activeCount = businessUnit.registers.filter(
    register => register.state === CashRegisterStateEnum.Active,
  ).length;

  return (
    <Card>
      <Link
        to={`/registers?unit=${businessUnit.taxObjectId}`}
        className="text-lg font-semibold text-ink-900 hover:text-brand-700"
      >
        {businessUnit.name}
      </Link>
      <Text size="sm" c="dimmed" mt={4}>
        {businessUnit.address}
      </Text>

      <div className="mt-4 border-t border-ink-900/8 pt-4">
        <Text size="sm" c="dimmed">
          {t("businessUnits.registersCount", {
            count: businessUnit.registers.length,
          })}
        </Text>
        <Text size="sm" c="dimmed" mt={2}>
          {t("businessUnits.activeCount", {
            count: activeCount,
            total: businessUnit.registers.length,
          })}
        </Text>
      </div>
    </Card>
  );
};
